import { Directive, Injectable } from '@angular/core';
import { BarraConsultaExportComponent } from './barra-consulta-export.component';

@Injectable({
  providedIn: 'root'
})
@Directive()
export class BarraConsultaExportServiceService extends BarraConsultaExportComponent {

}
